// extracted by mini-css-extract-plugin
export default {"panel":"Sublingual_panel__AGoKU","subHeader":"Sublingual_subHeader__2pHar","sectionHeader":"Sublingual_sectionHeader__8JaSW"};